<template>
  <b-modal
    id="InactiveTimeoutModal"
    ref="inactiveModal"
    class="modal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <template
      slot="modal-header"
    >
      <h5>Inactivity Logout</h5>
    </template>
    <p>
      You have not performed an action in awhile.
    </p>
    <p>
      You have {{ formattedTime }} remaining before you will be automatically logged out.
    </p>
    <p>
      To remain signed in please click the button below.
    </p>
    <template
      slot="modal-footer"
    >
      <button
        class="btn btn--primary"
        type="button"
        @click="stayLoggedIn()"
      >
        <span>Stay Logged In</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import StorageService from '@/api/Storage';
import UserClient from '@/api/UserClient';

const showWarningSeconds = 120;

const currentEpochTime = () => Math.floor(new Date().getTime() / 1000);

export default {
  name: 'InactiveTimeoutModal',
  data() {
    return {
      userClient: new UserClient(this.$http),

      expireTimeEpoch: null,
      currentTime: null,
    };
  },
  computed: {
    formattedTime() {
      const remainingSeconds = (this.expireTimeEpoch - this.currentTime);
      const minutesNumber = Math.floor(remainingSeconds / 60);
      const secondsNumber = remainingSeconds - (minutesNumber * 60);
      return `${(`00${minutesNumber}`).slice(-2)}:${(`00${secondsNumber}`).slice(-2)}`;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars, func-names
    '$store.getters.tokensUpdated': function (val, oldVal) {
      this.computeExpireTimeEpoch();
    },
  },
  mounted() {
    this.currentTime = currentEpochTime();
    this.computeExpireTimeEpoch();
    setInterval(() => {
      this.currentTime = currentEpochTime();
      const remainingSeconds = (this.expireTimeEpoch - this.currentTime);
      if (this.$store.getters.isAuthorized
        && remainingSeconds > 0
        && remainingSeconds < showWarningSeconds
      ) {
        this.$refs.inactiveModal.show();

        // Handle multiple browser windows that may show timeout warning
        this.computeExpireTimeEpoch();
      }

      if (this.$store.getters.isAuthorized
      && this.expireTimeEpoch
      && remainingSeconds <= 0) {
        this.$router.push({ name: 'logout' });
        if (this.$refs.inactiveModal) {
          this.$refs.inactiveModal.hide();
        }
      }

      if (this.$refs.inactiveModal && remainingSeconds > showWarningSeconds) {
        this.$refs.inactiveModal.hide();
      }
    }, 1000);
  },
  methods: {
    computeExpireTimeEpoch() {
      const refreshToken = StorageService.getItem('refreshToken');
      if (!refreshToken) {
        this.expireTimeEpoch = null;
        return;
      }

      const splitToken = refreshToken.split('.');
      if (splitToken.length !== 3) {
        this.expireTimeEpoch = null;
        return;
      }

      this.expireTimeEpoch = JSON.parse(atob(splitToken[1])).exp - 30;
    },
    cancel() {
      this.$refs.inactiveModal.hide();
    },
    stayLoggedIn() {
      this.$refs.inactiveModal.hide();
      this.expireTimeEpoch = null;

      // eslint-disable-next-line no-underscore-dangle
      this.userClient.refreshToken();
    },
  },
};
</script>

<style scoped lang="scss">

</style>
